import routerOptions0 from "/codebuild/output/src3183640832/src/consort-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}